import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AccountService } from './account.service';
import { Observable, map } from 'rxjs';

@Injectable()
export class AdminGuard implements CanActivate {
  constructor(
    private router: Router,
    private accountService: AccountService
  ) {
  }
  
  canActivate(): Observable<boolean> | boolean {
    var isAdmin = !!localStorage.getItem('isAdmin');
    if (!isAdmin) {
      return false;
    }

    return this.accountService.isLoggedIn$.pipe(
      map(isLoggedIn => {
        if (isLoggedIn) {
          return true;
        }
        
        this.router.navigate(['orders'], { queryParams: { redirectUri: this.router.url } });
        return false;
      })
    );
  }
}

